import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useEventIntelligenceAccess } from '@/features/events/useEventIntelligenceAccess';

export default function RequireEventIntelligence({ children }: { children?: ReactNode }) {
  const { enabled, isLoading } = useEventIntelligenceAccess();

  // Nothing renders until the API answers, so a rep without the flag never sees the feature flash.
  if (isLoading) return null;
  if (!enabled) return <Navigate to="/" replace />;

  return children ?? <Outlet />;
}
